import React from 'react';
import { Check } from 'lucide-react';

const CHILD_ACCENT = {
  orange: {
    border: 'border-highlight-orange',
    bg: 'bg-orange-50',
    avatar: 'bg-highlight-orange',
    color: 'text-highlight-orange',
    check: 'bg-highlight-orange border-highlight-orange',
  },
  blue: {
    border: 'border-blue-600',
    bg: 'bg-blue-50',
    avatar: 'bg-child-blue',
    color: 'text-blue-700',
    check: 'bg-blue-600 border-blue-600',
  },
};

const ChildCheckboxRow = ({ child, checked, onToggle }) => {
  const initials = [child.first_name, child.last_name]
    .filter(Boolean)
    .map(n => n.charAt(0).toUpperCase())
    .join('');

  const childAccent = CHILD_ACCENT[child.accentColor] || CHILD_ACCENT.orange;

  return (
    <button
      type="button"
      onClick={() => onToggle(child.id)}
      role="checkbox"
      aria-checked={checked}
      className={`w-full text-left flex items-center gap-4 p-4 sm:p-3 rounded-2xl border-[2.5px] cursor-pointer transition-all duration-150 min-h-[64px] sm:min-h-[56px] ${
        checked
          ? `${childAccent.border} ${childAccent.bg} shadow-sm`
          : 'border-border-gray bg-panel-gray'
      }`}
    >
      {/* Avatar */}
      {child.profile_photo ? (
        <img
          src={child.profile_photo}
          alt={child.first_name}
          className="w-12 h-12 sm:w-11 sm:h-11 rounded-full object-cover flex-shrink-0"
        />
      ) : (
        <div className={`w-12 h-12 sm:w-11 sm:h-11 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0 ${childAccent.avatar}`}>
          {initials || '?'}
        </div>
      )}

      {/* Name + subtitle */}
      <div className="flex-1 min-w-0">
        <p className={`text-xl sm:text-lg font-semibold truncate ${
          checked ? childAccent.color : 'text-text-dark'
        }`}>
          {child.first_name} {child.last_name}
        </p>
        <p className="text-base sm:text-sm text-text-medium truncate">
          {checked ? 'Will appear in their life story' : 'Not included'}
        </p>
      </div>

      {/* Checkbox square */}
      <div className={`w-[30px] h-[30px] sm:w-[26px] sm:h-[26px] rounded-lg border-[3px] flex items-center justify-center flex-shrink-0 transition-colors ${
        checked
          ? childAccent.check
          : 'border-border-gray bg-white'
      }`}>
        {checked && <Check size={16} className="text-white" strokeWidth={3} />}
      </div>
    </button>
  );
};

export default ChildCheckboxRow;
